export default __webpack_public_path__ + "static/media/Aircraft10-t.91ef5740.png";